import { FC, useContext } from 'react';
import { Spinner } from '@chakra-ui/react';
import { TableContext } from '.';
import styles from './BlankSlate.module.css';
import { CbButton } from '../Buttons/CbButton';
export const BlankSlate: FC = () => {
  const {
    bodyInfo,
    hasBulkSelect,
    loading,
    error,
    refetchTable,
    emptyState
  } = useContext(TableContext);
  const displayContent = () => {
    if (loading) {
      return <Spinner color="chonky.500" emptyColor="gray.200" size="lg" speed="0.65s" thickness="4px" />;
    } else if (error) {
      return <div className={styles.blankSlateError}>
          <span>Your request timed out. Please try again.</span>
          <CbButton onClick={() => refetchTable()} variant="outline" size="md">
            Refetch table data
          </CbButton>
        </div>;
    } else if (emptyState) {
      return emptyState;
    } else {
      return <span>Nothing to show</span>;
    }
  };

  /*
    If a table has bulk select enabled then we render an additional column for the select checkbox.
    This means that the colSpan is one more than the number of columns provided.
  */
  const colSpan = hasBulkSelect ? bodyInfo.length + 1 : bodyInfo.length;
  return <tr className={styles.blankSlateRow} data-sentry-component="BlankSlate" data-sentry-source-file="BlankSlate.tsx">
      <td className={styles.blankSlateCell} colSpan={colSpan}>
        {displayContent()}
      </td>
    </tr>;
};